import useAccordion from 'support/utilities/accordions/hooks/use-accordion'

export default function Collapse ({ name, children }) {
  const accordion = useAccordion()

  return accordion.isActive(name) ? children : null
}
